module.exports = __webpack_public_path__ + "media/review-badges/rank-50k-2f29508b.svg";